<div class="wrapper">
  <span translate class="text">WEBHOOKS.SHOW</span>
  <mat-select [(value)]="showType" small (selectionChange)="changeSelect()">
    <mat-option small [value]="'ALL'">{{'WEBHOOKS.ALL'| translate}}</mat-option>
    <mat-option small [value]="'PROJECT'">{{'WEBHOOKS.GLOBAL'| translate}}</mat-option>
    <mat-option small [value]="'MSISDN'">{{'WEBHOOKS.PER_NUMBER'| translate}}</mat-option>
  </mat-select>
</div>
